import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var DetailComparisonService = /** @class */ (function () {
    function DetailComparisonService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.loginUrl = this.env.servicePath;
    }
    DetailComparisonService.prototype.getDetailComparisonInfo = function (id) {
        var path = this.loginUrl + "GetDetailComparisonInfo/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailComparisonService.prototype.getDetailComparisonGroup = function (id, groupName) {
        var path = this.loginUrl + "GetDetailComparisonGroup/" + id + "/" + groupName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    DetailComparisonService.prototype.detailComparisonUpdateValue = function (id, groupName, headerName, value) {
        var path = this.loginUrl + "DetailComparisonUpdateValue/" + id + "/" + groupName + "/" + headerName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, value, httpOptions);
    };
    DetailComparisonService.prototype.detailComparisonAction = function (id, actionName, param) {
        if (param === void 0) { param = null; }
        var path = this.loginUrl + "DetailComparisonAction/" + id + "/" + actionName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, param, httpOptions);
    };
    DetailComparisonService.prototype.getFileCompareObject = function (id, definitionName, sheetName, data) {
        var path = this.loginUrl + "GetFileCompareObject/" + id + "/" + definitionName + "?sheetName=" + sheetName;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, data, httpOptions);
    };
    DetailComparisonService.ngInjectableDef = i0.defineInjectable({ factory: function DetailComparisonService_Factory() { return new DetailComparisonService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: DetailComparisonService, providedIn: "root" });
    return DetailComparisonService;
}());
export { DetailComparisonService };
